import { defineComponent, inferProps, renderSlot, type ReactiveComponent } from "vue-utils"
import BootstrapButton from "./BootstrapButton"
import Form from "./Form"
import FormButtons from "./FormButtons"

interface Props {
	okText: string
	onClose: () => void
}

const AlertForm: ReactiveComponent<Props> = (props, { slots }) => {
	return () => (
		<Form onSubmit={props.onClose}>
			{renderSlot(slots)}
			<hr class="w-full" />
			<FormButtons>
				<BootstrapButton color="secondary" type="submit">
					{props.okText}
				</BootstrapButton>
			</FormButtons>
		</Form>
	)
}

export default defineComponent(AlertForm, inferProps<Props>())
